import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Divider from '@material-ui/core/Divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FaSpinner } from 'react-icons/fa';
import Button from '@material-ui/core/Button';
import { Toast } from 'primereact/toast';
import { dominioDemandaCirurgica } from '../../config/database';

export default function ImpressaoRPH({ pedido, closeDialog, listarPedidosCirurgia }) {
  const [carregarSubmit, setCarregarSubmit] = useState(false);
  const [configuracoes, setConfiguracoes] = useState(undefined);
  const [carregar, setCarregar] = useState(false);
  const [indicacaoTransfusao, setIndicacaoTransfusao] = useState(undefined);
  const [valorHB, setValorHB] = useState(undefined);
  const [valorHT, setValorHT] = useState(undefined);
  const [valorPlaquetas, setValorPlaquetas] = useState(undefined);
  const [valorINR, setValorINR] = useState(undefined);
  const [valorFibrinogenio, setValorFibrinogenio] = useState(undefined);
  const [antecedenteGestacao, setAntecedenteGestacao] = useState(undefined);
  const [antecedenteTransfusao, setAntecedenteTransfusao] = useState(undefined);
  const [antecedenteTransfusaoQuando, setAntecedenteTransfusaoQuando] = useState(undefined);
  const [antecedenteTransfusaoReacao, setAntecedenteTransfusaoReacao] = useState(undefined);
  const [antecedenteTransfusaoTipoReacao, setAntecedenteTransfusaoTipoReacao] = useState(undefined);
  const [tipoTransfusao, setTipoTransfusao] = useState(undefined);
  const [transfusaoData, setTransfusaoData] = useState(undefined);
  const [toast, setToast] = useState(undefined);
  const [listaTipoTransfusao, setListaTipoTransfusao] = useState([]);
  const listaSimNaoSemInformacoes = [
    { texto: 'Sim', valor: 'S' },
    { texto: 'Não', valor: 'N' },
    { texto: 'Sem Informações', valor: 'SI' },
  ];

  const showWarn = (msg, severity) => {
    toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 3000,
    });
  };

  const getConfiguracoes = () => {
    setConfiguracoes(JSON.parse(localStorage.getItem('configuracoes')));
  };

  useEffect(() => {
    getConfiguracoes();

    setCarregar(true);
    dominioDemandaCirurgica.get(`/api/tipoTransfusao`).then(
      response => {
        setListaTipoTransfusao(response.data);
        setCarregar(false);
      },
      () => {
        setCarregarSubmit(false);
        showWarn('Erro ao imprimir!', 'warn');
      }
    );
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    const data = {
      indicacaoTransfusao,
      valorHB,
      valorHT,
      valorPlaquetas,
      valorINR,
      valorFibrinogenio,
      antecedenteGestacao: antecedenteGestacao?.valor,
      antecedenteTransfusao: antecedenteTransfusao?.valor,
      antecedenteTransfusaoQuando:
        antecedenteTransfusaoQuando === undefined ? null : antecedenteTransfusaoQuando,
      antecedenteTransfusaoReacao:
        antecedenteTransfusaoReacao === undefined ? null : antecedenteTransfusaoReacao,
      antecedenteTransfusaoTipoReacao:
        antecedenteTransfusaoTipoReacao === undefined ? null : antecedenteTransfusaoTipoReacao,
      idTipoTransfusao: tipoTransfusao?.id,
      transfusaoData: transfusaoData || null,
    };

    setCarregarSubmit(true);

    pedido.dataImpressaoRPH ?
      dominioDemandaCirurgica().then(promise => {
        window.open(`${promise.config.baseURL}/hemoterapicos/${pedido.id}`);
        setCarregarSubmit(false);
        closeDialog();
        listarPedidosCirurgia();
        document.location.reload(true);
      }) :
      dominioDemandaCirurgica.put(`/api/dadosImpressaoRPH/${pedido.id}`, data).then(
        async () => {
          await dominioDemandaCirurgica().then(promise => {
            window.open(`${promise.config.baseURL}/hemoterapicos/${pedido.id}`);
          });
          setCarregarSubmit(false);
          closeDialog();
          listarPedidosCirurgia();
          document.location.reload(true);
        },
        () => {
          setCarregarSubmit(false);
          showWarn('Erro ao imprimir!', 'warn');
        }
      );
  };

  const handleCamposTransfusaoAntecedente = () => {
    if (antecedenteTransfusao && antecedenteTransfusao.valor === 'S')
      return (
        <>
          <Grid item xs={9} sm={9}>
            <TextField
              autoComplete="off"
              name="antecedenteTransfusaoQuando"
              variant="outlined"
              fullWidth
              id="antecedenteTransfusaoQuando"
              label="Quando?"
              InputLabelProps={{ shrink: true }}
              value={antecedenteTransfusaoQuando}
              onChange={e => setAntecedenteTransfusaoQuando(e.target.value)}
              required
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
          <Grid item xs={9} sm={9}>
            <TextField
              autoComplete="off"
              name="antecedenteTransfusaoReacao"
              variant="outlined"
              fullWidth
              id="antecedenteTransfusaoReacao"
              label="Reação Transf. Anterior"
              InputLabelProps={{ shrink: true }}
              value={antecedenteTransfusaoReacao}
              onChange={e => setAntecedenteTransfusaoReacao(e.target.value)}
              required
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
          <Grid item xs={9} sm={9}>
            <TextField
              autoComplete="off"
              name="antecedenteTransfusaoTipoReacao"
              variant="outlined"
              fullWidth
              id="antecedenteTransfusaoTipoReacao"
              label="Tipo da reação à Transf. Anterior"
              InputLabelProps={{ shrink: true }}
              value={antecedenteTransfusaoTipoReacao}
              onChange={e => setAntecedenteTransfusaoTipoReacao(e.target.value)}
              required
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
        </>
      );
    return null;
  };

  const handleDataTipoTransfusao = value => {
    const dataSelecionada = new Date(value);
    const dataAtual = new Date();
    if (dataSelecionada <= dataAtual) {
      showWarn('A data não pode ser retroativa', 'warn');
      setTransfusaoData('');
    } else setTransfusaoData(value);
  };

  const handleDataTipoTransfusaoRender = () => {
    if (tipoTransfusao && tipoTransfusao.id === configuracoes.tipoTransfusaoProgramada)
      return (
        <Grid item xs={12} sm={12}>
          <TextField
            id="datetime-local"
            label="Data da Transfusão"
            type="datetime-local"
            InputLabelProps={{
              shrink: true,
            }}
            value={transfusaoData}
            onChange={e => handleDataTipoTransfusao(e.target.value)}
            required
          />
        </Grid>
      );
    return null;
  };

  if (carregar) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <Container className="container-pedido-internacao">
      <Toast
        ref={el => {
          setToast(el);
        }}
        position="top-right"
      />
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {pedido.dataImpressaoRPH ?
            <strong className="confirmacao-de-reimpressao">Este documento já foi impresso. <br />Tem certeza de que deseja reimprimi-lo?</strong> :
            <>
              <Grid item xs={12} sm={12}>
                <TextField
                  autoComplete="off"
                  name="indicacaoTransfusao"
                  variant="outlined"
                  fullWidth
                  id="indicacaoTransfusao"
                  label="Indicação de transfusão"
                  InputLabelProps={{ shrink: true }}
                  value={indicacaoTransfusao}
                  onChange={e => setIndicacaoTransfusao(e.target.value)}
                  inputProps={{ maxLength: 500 }}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <br />
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                Dados laboratoriais
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  autoComplete="off"
                  name="valorHB"
                  variant="outlined"
                  fullWidth
                  id="valorHB"
                  label="Hb"
                  InputLabelProps={{ shrink: true }}
                  value={valorHB}
                  onChange={e => setValorHB(e.target.value)}
                  type="number"
                  required
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  autoComplete="off"
                  variant="outlined"
                  fullWidth
                  id="valorHT"
                  label="Ht"
                  InputLabelProps={{ shrink: true }}
                  value={valorHT}
                  onChange={e => setValorHT(e.target.value)}
                  type="number"
                  required
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  autoComplete="off"
                  name="valorPlaquetas"
                  variant="outlined"
                  fullWidth
                  id="valorPlaquetas"
                  label="Plaquetas"
                  InputLabelProps={{ shrink: true }}
                  value={valorPlaquetas}
                  onChange={e => setValorPlaquetas(e.target.value)}
                  type="number"
                  required
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  autoComplete="off"
                  name="valorINR"
                  variant="outlined"
                  fullWidth
                  id="valorINR"
                  label="INR"
                  InputLabelProps={{ shrink: true }}
                  value={valorINR}
                  onChange={e => setValorINR(e.target.value)}
                  type="number"
                  required
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  autoComplete="off"
                  name="valorFibrinogenio"
                  variant="outlined"
                  fullWidth
                  id="valorFibrinogenio"
                  label="Fibrinogênio"
                  InputLabelProps={{ shrink: true }}
                  value={valorFibrinogenio}
                  onChange={e => setValorFibrinogenio(e.target.value)}
                  type="number"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <br />
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                Antecedentes
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id="antecedenteGestacao"
                  options={listaSimNaoSemInformacoes}
                  getOptionLabel={option => option.texto}
                  option
                  fullWidth
                  value={antecedenteGestacao}
                  onChange={(e, value) => setAntecedenteGestacao(value)}
                  renderInput={params => (
                    <TextField {...params} required label="Gestações" variant="outlined" />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id="antecedenteTransfusao"
                  options={listaSimNaoSemInformacoes}
                  getOptionLabel={option => option.texto}
                  option
                  fullWidth
                  value={antecedenteTransfusao}
                  onChange={(e, value) => setAntecedenteTransfusao(value)}
                  renderInput={params => (
                    <TextField {...params} required label="Transfusões Anteriores" variant="outlined" />
                  )}
                />
              </Grid>
              {handleCamposTransfusaoAntecedente()}
              <Grid item xs={12} sm={12}>
                <br />
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                Tipo de Transfusão
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id="tipoTransfusao"
                  options={listaTipoTransfusao}
                  getOptionLabel={option => option.descricao}
                  option
                  fullWidth
                  value={tipoTransfusao}
                  onChange={(e, value) => {
                    if (value.id !== configuracoes.tipoTransfusaoProgramada) setTransfusaoData(null);
                    setTipoTransfusao(value);
                  }}
                  renderInput={params => (
                    <TextField {...params} required label="Tipo de Transfusão" variant="outlined" />
                  )}
                />
              </Grid>
            </>
          }

          {handleDataTipoTransfusaoRender()}

          <Grid item xs={12} sm={12}>
            <div className="div-botoes">
              <Button type="submit" variant="contained" color="primary">
                {carregarSubmit ? (
                  <FaSpinner color="#FFF" className="loading" size={14} />
                ) : (
                  <> Imprimir </>
                )}
              </Button>
              <Button
                type="button"
                variant="contained"
                color="secondary"
                onClick={() => closeDialog()}
              >
                Cancelar
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
